import React from 'react';
import { useNavigate } from 'react-router-dom';

const NavigateWrapper = (Component) => {
    return function NavigateWrapper(props) {
    const navigate = useNavigate();
    return <Component {...props} navigate={navigate} />;
    }
 };

 export default NavigateWrapper;